<div class="info-container" *ngIf="!editProducts">

    <div class="label header">{{ 'bikeshop.rentals.booking.customer_info' | translate }}</div>

    <div class="row margin-top-16">
        <div class="col-md-2 label">{{ "general.name" | translate }}:</div>
        <div class="col-md-3 value">
            <p-inplace #Name>
                <span pInplaceDisplay>
                    {{ cyclist.Name }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="cyclist.Name"
                            (keyup.enter)="updateCyclist(Name, 'Name')" (blur)="updateCyclist(Name, 'Name')" />
                        <span class="p-inputgroup-addon" (click)="updateCyclist(Name, 'Name')"><i class="fa fa-check"
                                [ngClass]="{ red: cyclist.Name && cyclist.Name.length > 0 }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
        <div class="col-md-3 label">{{ "general.surname" | translate }}:</div>
        <div class="col-md-4 value">
            <p-inplace #Surname>
                <span pInplaceDisplay>
                    {{ cyclist.Surname }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="cyclist.Surname"
                            (keyup.enter)="updateCyclist(Surname, 'Surname')"
                            (blur)="updateCyclist(Surname, 'Surname')" />
                        <span class="p-inputgroup-addon" (click)="updateCyclist(Surname, 'Surname')"><i
                                class="fa fa-check" [ngClass]="{
                    red: cyclist.Surname && cyclist.Surname.length > 0
                  }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-2 label">{{ "general.phone" | translate }}:</div>
        <div class="col-md-3 value">
            <p-inplace #phoneNumber>
                <span pInplaceDisplay>
                    {{ cyclist.PhoneNumber }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="cyclist.PhoneNumber"
                            (keyup.enter)="updateCyclist(phoneNumber, 'PhoneNumber')"
                            (blur)="updateCyclist(phoneNumber, 'PhoneNumber')" />
                        <span class="p-inputgroup-addon" (click)="updateCyclist(phoneNumber, 'PhoneNumber')"><i
                                class="fa fa-check" [ngClass]="{
                    red: cyclist.PhoneNumber && cyclist.PhoneNumber.length > 0
                  }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
        <div class="col-md-3 label">{{ "general.email" | translate }}:</div>
        <div class="col-md-4 value">
            <p-inplace #Email>
                <span pInplaceDisplay>
                    {{ cyclist.Email }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="cyclist.Email"
                            (keyup.enter)="updateCyclist(Email, 'Email')" (blur)="updateCyclist(Email, 'Email')" />
                        <span class="p-inputgroup-addon" (click)="updateCyclist(Email, 'Email')"><i class="fa fa-check"
                                [ngClass]="{
                    red:  validateEmail()
                  }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
    </div>
</div>

<div class="info-container" *ngIf="rentalStoreRules.hasDemoProducts">
    <div class="row">
        <div class="col-md-2 label">{{ 'bikeshop.rentals.booking.reservation_type' | translate }}:</div>
        <div class="col-md-10">
            <div class="reservation-type-container">
                <div><p-radioButton name="type" [value]="false" [disabled]="true"
                        label="{{ 'bikeshop.rentals.booking.type_rental' | translate }}"
                        [(ngModel)]="reservation.isDemo"></p-radioButton></div>
                <div><p-radioButton name="type" [value]="true" [disabled]="true"
                        label="{{ 'bikeshop.rentals.booking.type_demo' | translate }}"
                        [(ngModel)]="reservation.isDemo"></p-radioButton></div>
            </div>
        </div>
    </div>
</div>

<div class="info-container" *ngIf="!editProducts && rentalStoreRules.captureAddress">

    <div class="label header">{{ 'bikeshop.rentals.booking.address' | translate }}</div>

    <div class="row margin-top-16">
        <div class="col-md-2 label">{{ "bikeshop.rentals.booking.addressline1" | translate }}:</div>
        <div class="col-md-3 value">
            <p-inplace #Addressline1>
                <span pInplaceDisplay>
                    {{ reservation.addressline1 }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="reservation.addressline1"
                            (keyup.enter)="updateAddress(Addressline1, 'Addressline1')"
                            (blur)="updateAddress(Addressline1, 'Addressline1')" />
                        <span class="p-inputgroup-addon" (click)="updateAddress(Addressline1, 'Addressline1')"><i
                                class="fa fa-check"
                                [ngClass]="{ red: reservation.addressline1 && reservation.addressline1.length > 0 }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
        <div class="col-md-3 label">{{ "bikeshop.rentals.booking.addressline2" | translate }}:</div>
        <div class="col-md-4 value">
            <p-inplace #Addressline2>
                <span pInplaceDisplay>
                    {{ reservation.addressline2 }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="reservation.addressline2"
                            (keyup.enter)="updateAddress(Addressline2, 'Addressline2')"
                            (blur)="updateAddress(Addressline2, 'Addressline2')" />
                        <span class="p-inputgroup-addon" (click)="updateAddress(Addressline2, 'Addressline2')"><i
                                class="fa fa-check red"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-2 label">{{ "bikeshop.rentals.booking.city" | translate }}:</div>
        <div class="col-md-3 value">
            <p-inplace #City>
                <span pInplaceDisplay>
                    {{ reservation.city }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="reservation.city"
                            (keyup.enter)="updateAddress(City, 'City')" (blur)="updateAddress(City, 'City')" />
                        <span class="p-inputgroup-addon" (click)="updateAddress(City, 'City')"><i class="fa fa-check"
                                [ngClass]="{ red: reservation.city && reservation.city.length > 0 }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
        <div class="col-md-3 label">{{ "bikeshop.rentals.booking.state" | translate }}:</div>
        <div class="col-md-4 value">
            <p-inplace #State>
                <span pInplaceDisplay>
                    {{ reservation.state }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="reservation.state"
                            (keyup.enter)="updateAddress(State, 'State')" (blur)="updateAddress(State, 'State')" />
                        <span class="p-inputgroup-addon" (click)="updateAddress(State, 'State')"><i class="fa fa-check"
                                [ngClass]="{ red: reservation.state && reservation.city.state > 0 }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-2 label">{{ "bikeshop.rentals.booking.country" | translate }}:</div>
        <div class="col-md-3 value">
            <p-inplace #Country>
                <span pInplaceDisplay>
                    {{ reservation.country }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="reservation.country"
                            (keyup.enter)="updateAddress(Country, 'Country')"
                            (blur)="updateAddress(Country, 'Country')" />
                        <span class="p-inputgroup-addon" (click)="updateAddress(Country, 'Country')"><i
                                class="fa fa-check"
                                [ngClass]="{ red: reservation.country && reservation.country.length > 0 }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
        <div class="col-md-3 label">{{ "bikeshop.rentals.booking.zipcode" | translate }}:</div>
        <div class="col-md-4 value">
            <p-inplace #ZipCode>
                <span pInplaceDisplay>
                    {{ reservation.zipCode }}
                </span>
                <span pInplaceContent>
                    <div class="p-inputgroup">
                        <input pInputText type="text" [(ngModel)]="reservation.zipCode"
                            (keyup.enter)="updateAddress(ZipCode, 'ZipCode')"
                            (blur)="updateAddress(ZipCode, 'ZipCode')" />
                        <span class="p-inputgroup-addon" (click)="updateAddress(ZipCode, 'ZipCode')"><i
                                class="fa fa-check" [ngClass]="{
                    red: reservation.zipCode && reservation.zipCode.length > 0
                  }"></i></span>
                    </div>
                </span>
            </p-inplace>
        </div>
    </div>
</div>

<div class="row margin-top-8" *ngIf="!editDeliveries && !editProducts && !editDate">
    <div class="col-4" *ngIf="affiliates && affiliates.length > 0 && !reservation.affiliate"><button pButton
            class="p-button-raised p-mini full-width" label="{{'bikeshop.rentals.booking.link_affiliate' | translate}}"
            (click)="editAffiliate=!editAffiliate"
            [disabled]="editAffiliate || editDeliveries || reservation.reservationStatusID > 30"></button></div>
    <div class="col-4"
        *ngIf="(reservation.storeDeliveriesEnabled && (!reservation.deliveryInformation.id && !reservation.collectionInformation.id))">
        <button pButton class="p-button-raised p-mini full-width"
            label="{{'bikeshop.rentals.booking.add_delivery_collection' | translate}}" (click)="beginDeliveriesEdit()"
            [disabled]="editDeliveries || editAffiliate"></button>
    </div>
</div>

<div class="info-container"
    *ngIf="!editProducts && affiliates && affiliates.length > 1 && (editAffiliate || reservation.affiliate)">

    <div class="label header">{{ 'bikeshop.rentals.booking.affilaite' | translate }}</div>

    <div class="row margin-top-16">
        <div class="col-md-2 label">{{ "bikeshop.rentals.booking.linked_affilaite" | translate }}:</div>
        <div class="col-md-4 value">
            <p-inplace #affiliatesList [disabled]="reservation.reservationStatusID > 30" *ngIf="reservation.affiliate">
                <span pInplaceDisplay>
                    {{ reservation.affiliate ? reservation.affiliate.affiliateName : "" }}
                </span>
                <span pInplaceContent class="dropdown-clear">
                    <p-dropdown [options]="affiliates" [(ngModel)]="affiliateID" (onChange)="updateAffiliate()">
                    </p-dropdown>
                    <div class="col-md-1 remove-affiliate" *ngIf="reservation.affiliate && reservation.affiliate.id">
                        <span class="fa fa-times-circle" (click)="clearAffiliate()"></span>
                    </div>
                </span>
            </p-inplace>
            <p-dropdown *ngIf="!reservation.affiliate" [options]="affiliates" [(ngModel)]="affiliateID"
                (onChange)="updateAffiliate()">
            </p-dropdown>
        </div>
    </div>
</div>

<div class="info-container"
    *ngIf="(reservation.deliveryInformation.id || reservation.collectionInformation.id) && (!editDeliveries && !editProducts) || (editDeliveries && editProducts)">
    <div class="header-edit">
        <div class="label header">{{'bikeshop.rentals.booking.delivery_collection_information' | translate}}</div>
        <div class="fa fa-pencil" *ngIf="canEditReservation && !editDeliveries" (click)="beginDeliveriesEdit()"></div>

    </div>

    <div *ngIf="!editDeliveries">
        <div>
            <div *ngIf="!reservation.deliveryInformation.id" class="no-delivery">
                <div class="label margin-top-8">{{ 'bikeshop.rentals.booking.no_delivery' | translate }}</div>
            </div>
            <div class="rental-duration" *ngIf="reservation.deliveryInformation.id">
                <div>{{ 'bikeshop.rentals.booking.delivery_information' | translate }}:</div>
                <ul>
                    <li><b>{{'bikeshop.rentals.summary.address' | translate }}:</b>
                        {{reservation.deliveryInformation.fullAddress}}</li>
                    <li><b>{{'bikeshop.collections.date' | translate }}:</b>
                        {{reservation.deliveryInformation.scheduleDate | date : "d MMM yyyy"}}</li>
                    <li><b>{{'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate }}:</b>
                        {{'1970-01-01T'+reservation.deliveryInformation.scheduleTimeSlotStart | date : "h:mma"}} -
                        {{'1970-01-01T'+reservation.deliveryInformation.scheduleTimeSlotEnd | date : "h:mma"}}</li>
                </ul>
            </div>

            <div class="rental-duration" *ngIf="reservation.collectionInformation.id">
                <div>{{ 'bikeshop.rentals.booking.collection_information' | translate }}:</div>
                <ul>
                    <li><b>{{'bikeshop.rentals.summary.address' | translate }}:</b>
                        {{reservation.collectionInformation.fullAddress}}</li>
                    <li><b>{{'bikeshop.collections.date' | translate }}:</b>
                        {{reservation.collectionInformation.scheduleDate | date : "d MMM yyyy"}}</li>
                    <li><b>{{'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate }}:</b>
                        {{'1970-01-01T'+reservation.collectionInformation.scheduleTimeSlotStart | date : "h:mma"}} -
                        {{'1970-01-01T'+reservation.collectionInformation.scheduleTimeSlotEnd | date : "h:mma"}}</li>
                </ul>
            </div>

            <div class="rental-duration"
                *ngIf="reservation.deliveryInformation.id && !reservation.collectionInformation.id">
                <div>{{ 'bikeshop.rentals.booking.no_collection' | translate }}:</div>
                <ul>
                    <li><b>{{'bikeshop.rentals.booking.no_collection_return_date' | translate }}:</b>
                        {{reservation.toDate
                        | date : "h:mma, d MMM yyyy"}}</li>
                </ul>
            </div>
        </div>
    </div>

    <div *ngIf="editDeliveries">
        <div>
            <div class="rental-duration" *ngIf="reservation.deliveryInformation">
                <div class="row margin-top-16">
                    <div class="col-md-3 label">{{'bikeshop.modal.update_job_card.collections.delivery' | translate }}:
                    </div>
                    <div class="col-md-3 flex"><p-inputSwitch
                            [(ngModel)]="reservation.deliveryInformation.isDelivery"></p-inputSwitch></div>
                    <div *ngIf="!reservation.deliveryInformation.isDelivery" class="label col-md-3"
                        [ngClass]="{ 'red' : reservation.fromDate === null}">
                        {{ 'bikeshop.rentals.booking.from' | translate }}:
                    </div>
                    <div *ngIf="!reservation.deliveryInformation.isDelivery" class="col-md-3">
                        <div class="input-icon-right">
                            <p-calendar #calendar inputId="fromDate" [dateFormat]="countryData.DatePickerFormat"
                                [hideOnDateTimeSelect]="true" [(ngModel)]="reservation.fromDate" [readonlyInput]="true"
                                [hourFormat]="'12'" [showOtherMonths]="false" [showTime]="true" [showSeconds]="false"
                                [stepHour]="1" [stepMinute]="15" (onClose)="datesUpdated()"></p-calendar>
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
                <div class="row margin-top-8" *ngIf="reservation.deliveryInformation.isDelivery">
                    <div class="col-md-3 label"
                        [ngClass]="{'red': reservation.deliveryInformation.isDelivery && !reservation.deliveryInformation.fullAddress}">
                        {{ 'bikeshop.modal.update_job_card.collections.delivery_address' | translate }}:
                    </div>
                    <div class="col-md-6">
                        <div class="p-inputgroup">
                            <p-autoComplete [(ngModel)]="reservation.deliveryInformation.fullAddress"
                                [suggestions]="addressOptions" (completeMethod)="searchAddress($event, 'DELIVERY')"
                                (onSelect)="onAddressSelect($event,'DELIVERY')" field="address"></p-autoComplete>
                            <div *ngIf="deliveryAddressLoading">
                                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                                    fill="transparent" animationDuration=".5s"></p-progressSpinner>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row"
                    *ngIf="reservation.deliveryInformation.fullAddress && reservation.deliveryInformation.addressOutOfRange">
                    <div class="col-3"></div>
                    <div class="col-9 red bold">{{ 'bikeshop.rentals.booking.no_areas_for_address' | translate }}</div>
                </div>
                <div class="row margin-top-8" *ngIf="reservation.deliveryInformation.isDelivery">
                    <div class="col-md-3 label" [ngClass]="{'red': !reservation.deliveryInformation.scheduleDate}">
                        {{'bikeshop.collections.date' | translate }}:</div>
                    <div class="col-md-3">
                        <div class="input-icon-right">
                            <p-calendar #calendar inputId="basic" [minDate]="minDate"
                                placeholder="{{'bikeshop.modal.update_job_card.collections.delivery_date' | translate}}"
                                [dateFormat]="countryData.DatePickerFormat" [hideOnDateTimeSelect]="true"
                                [(ngModel)]="reservation.deliveryInformation.scheduleDate" [readonlyInput]="true"
                                [disabledDates]="disabledDeliveryDates" (onSelect)="deliveryDateSelected($event)"
                                [disabled]="!reservation.deliveryInformation.addressDetails && !reservation.deliveryInformation.areaID"
                                (onFocus)="datePickerFocused($event)" (onClose)="datePickerClosed($event)"
                                [showOtherMonths]="false" (onMonthChange)="onDeliveryMonthChange($event)"></p-calendar>
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
                <div class="row margin-top-8" *ngIf="reservation.deliveryInformation.isDelivery">
                    <div class="col-md-3 label" [ngClass]="{'red': !reservation.deliveryInformation.slot}">
                        {{'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate }}:</div>
                    <div class="col-md-3"><p-dropdown [options]="deliveryTimeSlots"
                            (onChange)="selectDeliveryTimeSlot($event)"
                            [disabled]="reservation.deliveryInformation.scheduleDate=== null || deliveryTimeSlots.length === 0"
                            [ngModel]="reservation.deliveryInformation.slot" optionLabel="label"
                            placeholder="{{ 'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate}}"></p-dropdown>
                    </div>
                </div>
            </div>


            <div class="rental-duration" *ngIf="reservation.collectionInformation">
                <div class="row margin-top-16">
                    <div class="col-md-3 label">{{'bikeshop.modal.update_job_card.collections.collection' | translate
                        }}:</div>
                    <div class="col-md-3 flex"><p-inputSwitch
                            [(ngModel)]="reservation.collectionInformation.isCollection"></p-inputSwitch></div>

                    <div *ngIf="!reservation.collectionInformation.isCollection" class="label col-md-3"
                        [ngClass]="{ 'red' : reservation.toDate === null || reservation.toDate <= reservation.fromDate}">
                        {{ 'bikeshop.rentals.booking.to' | translate }}:
                    </div>
                    <div *ngIf="!reservation.collectionInformation.isCollection" class="col-md-3">
                        <div class="input-icon-right">
                            <p-calendar #calendar inputId="toDate" [dateFormat]="countryData.DatePickerFormat"
                                [hideOnDateTimeSelect]="true" [(ngModel)]="reservation.toDate" [readonlyInput]="true"
                                [hourFormat]="'12'" [showOtherMonths]="false" [showTime]="true" [showSeconds]="false"
                                [stepHour]="1" [stepMinute]="15" [minDate]="reservation.fromDate"
                                (onClose)="datesUpdated()"></p-calendar>
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
                <div class="row margin-top-8" *ngIf="reservation.collectionInformation.isCollection">
                    <div class="col-md-3 label"
                        [ngClass]="{'red': reservation.collectionInformation.isCollection && !reservation.collectionInformation.fullAddress}">
                        {{ 'bikeshop.modal.update_job_card.collections.collection_address' | translate }}:
                    </div>
                    <div class="col-md-6">
                        <div class="p-inputgroup">
                            <p-autoComplete [(ngModel)]="reservation.collectionInformation.fullAddress"
                                [suggestions]="addressOptions" (completeMethod)="searchAddress($event, 'COLLECTION')"
                                (onSelect)="onAddressSelect($event,'COLLECTION')" field="address"></p-autoComplete>
                            <div *ngIf="collectionAddressLoading">
                                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                                    fill="transparent" animationDuration=".5s"></p-progressSpinner>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row"
                    *ngIf="reservation.collectionInformation.fullAddress && reservation.deliveryInformation.addressOutOfRange">
                    <div class="col-3"></div>
                    <div class="col-9 red bold">{{ 'bikeshop.rentals.booking.no_areas_for_address' | translate }}</div>
                </div>
                <div class="row margin-top-8" *ngIf="reservation.collectionInformation.isCollection">
                    <div class="col-md-3 label" [ngClass]="{'red': !reservation.collectionInformation.scheduleDate}">
                        {{'bikeshop.collections.date' | translate }}:</div>
                    <div class="col-md-3">
                        <div class="input-icon-right">
                            <p-calendar #calendar inputId="basic" [minDate]="minCollectionDate"
                                [maxDate]="maxCollectionDate"
                                placeholder="{{'bikeshop.modal.update_job_card.collections.collection_date' | translate}}"
                                [dateFormat]="countryData.DatePickerFormat" [hideOnDateTimeSelect]="true"
                                [(ngModel)]="reservation.collectionInformation.scheduleDate" [readonlyInput]="true"
                                [disabledDates]="disabledCollectionDates" (onSelect)="collectionDateSelected($event)"
                                [disabled]="!reservation.collectionInformation.addressDetails && !reservation.collectionInformation.areaID"
                                (onFocus)="datePickerFocused($event)" (onClose)="datePickerClosed($event)"
                                [showOtherMonths]="false"
                                (onMonthChange)="onCollectionMonthChange($event)"></p-calendar>
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
                <div class="row margin-top-8" *ngIf="reservation.collectionInformation.isCollection">
                    <div class="col-md-3 label" [ngClass]="{'red': !reservation.collectionInformation.slot}">
                        {{'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate }}:</div>
                    <div class="col-md-3"><p-dropdown [options]="collectionTimeSlots"
                            (onChange)="selectCollectionTimeSlot($event)"
                            [disabled]="reservation.collectionInformation.scheduleDate=== null || collectionTimeSlots.length === 0"
                            [ngModel]="reservation.collectionInformation.slot" optionLabel="label"
                            placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}"></p-dropdown>
                    </div>
                </div>
            </div>
        </div>


        <div *ngIf="rentalStoreRules.allowFixedRentalOptions && !rentalStoreRules.allowFlexibleRentalOptions">
            <div class="row margin-top-16">
                <div class="col-md-12 label" [ngClass]="{'red bold': selectedTimeUnit === null}">
                    {{ 'bikeshop.rentals.booking.override_time_unit' | translate }}
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="label col-md-12">
                    <div class="duration-container">
                        <div *ngFor="let timeUnit of availableTimeUnits" class="custom-button"
                            [ngClass]="{'selected': timeUnit == selectedTimeUnit}"
                            (click)="selectedTimeUnit=timeUnit;reservation.unitType = timeUnit.unitType">
                            {{timeUnit.unit}} {{timeUnit.unitType}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="rentalStoreRules.allowFlexibleRentalOption && reservation.rentalDays > 0">
            <div class="rental-days-message">
                <div>{{
                    'bikeshop.rentals.booking.days_reserved_exact' | translate : {days: reservation.rentalDays} }}
                </div>
            </div>
        </div>

    </div>
</div>


<div class="info-container"
    *ngIf="!reservation.deliveryInformation.id && (!editDate && !editProducts) || (editDate && editProducts)">
    <div class="header-edit">
        <div class="label header">{{'bikeshop.rentals.booking.reservation_dates' | translate}}</div>
        <div class="fa fa-pencil" *ngIf="canEditReservation && !editDate" (click)="beginDateEdit()"></div>
        <!-- <div *ngIf="editDate && !reservation.overrideDate"><span>{{ 'bikeshop.rentals.booking.override_date' | translate }}</span><p-inputSwitch
          [(ngModel)]="overrideDateControl" (onChange)="dateOverrideUpdated()"></p-inputSwitch></div> -->
    </div>

    <div *ngIf="!editDate">
        <div>
            <div class="rental-duration">
                <div>{{ 'bikeshop.rentals.booking.from_date' | translate }}:</div>
                <!-- <ul>
                  <li>{{reservation.fromDate | date : countryData.angularDateFormat + " HH:mm a"}} - {{reservation.toDate | date :
                    countryData.angularDateFormat + " HH:mm a"}}</li>
                </ul> -->
                <ul>
                    <li><b>{{'bikeshop.report.from_date' | translate }}:</b> <span
                            class="fa fa-clock-o"></span>{{reservation.fromDate | date : "h:mma, d MMM yyyy"}}</li>
                    <li><b>{{'bikeshop.report.to_date' | translate }}:</b> <span
                            class="fa fa-clock-o"></span>{{reservation.toDate
                        | date : "h:mma, d MMM yyyy"}}</li>
                </ul>
            </div>
        </div>
        <div class="rental-duration margin-top-16">
            <div>{{ 'bikeshop.rentals.booking.rental_duration' | translate }}:</div>
            <ul>
                <li *ngIf="reservation.reservationDuration.days">{{reservation.reservationDuration.days | number :
                    '.0-2'}} {{
                    reservation.reservationDuration.days > 1 ? ('bikeshop.rentals.booking.days' | translate) :
                    ('bikeshop.rentals.booking.day' | translate)}}</li>
                <li *ngIf="reservation.reservationDuration.hours">{{reservation.reservationDuration.hours | number :
                    '.0-2'}}
                    {{
                    reservation.reservationDuration.hours > 1 ? ('bikeshop.rentals.booking.hours' | translate) :
                    ('bikeshop.rentals.booking.hour' | translate)}}</li>
            </ul>
        </div>
    </div>

    <div *ngIf="editDate">
        <div *ngIf="!(overrideDateControl || reservation.overrideDate)">
            <div class="row margin-top-16">
                <div class="label col-md-2"
                    [ngClass]="{ 'red' : (reservation.fromDate < minDate) && canEditReservation}">
                    {{ 'bikeshop.rentals.booking.from_date' | translate }}:
                </div>
                <div class="col-md-3">
                    <div class="input-icon-right">
                        <p-calendar #calendar inputId="basic" [minDate]="minDate"
                            [dateFormat]="countryData.DatePickerFormat" [hideOnDateTimeSelect]="true"
                            [(ngModel)]="reservation.fromDate" [readonlyInput]="true" [disabledDates]="disabledDates"
                            (onSelect)="fromDateSelected($event)" [disabled]="!canEditReservation"
                            (onFocus)="datePickerFocused($event)" (onClose)="datePickerClosed($event)"
                            [showOtherMonths]="false" (onMonthChange)="onMonthChange()"></p-calendar>
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
            </div>

            <div *ngIf="loadingAvailability">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                    animationDuration=".5s">
                </p-progressSpinner>
            </div>

            <div class="row margin-top-16"
                *ngIf="reservation.fromDate && availableSlots && availableSlots.length > 0 && !loadingAvailability">
                <div class="col-md-2 label" [ngClass]="{'red' : !reservation.selectedSlot}">{{
                    'bikeshop.rentals.booking.pickup_time' | translate }}:
                </div>
                <div class="col-md-10">
                    <div class="slots-container">
                        <div *ngFor="let slot of availableSlots" (click)="slotSelected(slot)" class="custom-button"
                            [ngClass]="{'selected': slot === reservation.selectedSlot}">
                            <div>{{slot.label}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-top-16"
                *ngIf="reservation.fromDate && reservation.selectedSlot && reservation.selectedSlot.durations && !loadingAvailability">
                <div class="col-md-2 label" [ngClass]="{'red' : !reservation.selectedDuration}">{{
                    'bikeshop.rentals.booking.rental_duration' | translate }}:
                </div>
                <div class="col-md-10">
                    <div class="duration-container">
                        <div *ngFor="let duration of reservation.selectedSlot.durations"
                            (click)="durationSelected(duration)" class="custom-button"
                            [ngClass]="{'selected': duration === reservation.selectedDuration}">
                            <div>{{duration.unit}} {{duration.unitType}}{{duration.unit != 1 ? 's' : ''}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="margin-top-16 red bold" *ngIf="canEditReservation && reservation.fromDate < minDate">
                {{ 'bikeshop.rentals.booking.date_past_validation_warning' | translate }}
            </div>
        </div>


        <div *ngIf="overrideDateControl || reservation.overrideDate">
            <div class="row margin-top-16">
                <div class="label col-md-2" [ngClass]="{ 'red' : reservation.fromDate === null}">
                    {{ 'bikeshop.rentals.booking.from' | translate }}:
                </div>
                <div class="col-md-3">
                    <div class="input-icon-right">
                        <p-calendar #calendar inputId="fromDate" [dateFormat]="countryData.DatePickerFormat"
                            [hideOnDateTimeSelect]="true" [(ngModel)]="reservation.fromDate" [readonlyInput]="true"
                            [hourFormat]="'12'" [showOtherMonths]="false" [showTime]="true" [showSeconds]="false"
                            [stepHour]="1" [stepMinute]="15" (onClose)="datesUpdated()"></p-calendar>
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
                <div class="label col-md-2"
                    [ngClass]="{ 'red' : reservation.toDate === null || reservation.toDate <= reservation.fromDate}">
                    {{ 'bikeshop.rentals.booking.to' | translate }}:
                </div>
                <div class="col-md-3">
                    <div class="input-icon-right">
                        <p-calendar #calendar inputId="toDate" [dateFormat]="countryData.DatePickerFormat"
                            [hideOnDateTimeSelect]="true" [(ngModel)]="reservation.toDate" [readonlyInput]="true"
                            [hourFormat]="'12'" [showOtherMonths]="false" [showTime]="true" [showSeconds]="false"
                            [stepHour]="1" [stepMinute]="15" [minDate]="reservation.fromDate"
                            (onClose)="datesUpdated()"></p-calendar>
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
            </div>


            <div *ngIf="showFixedSlots()">
                <div class="row margin-top-16">
                    <div class="col-md-12 label" [ngClass]="{'red bold': selectedTimeUnit === null}">
                        {{ 'bikeshop.rentals.booking.override_time_unit' | translate }}
                    </div>
                </div>
                <div class="row margin-top-8">
                    <div class="label col-md-12">
                        <div class="duration-container">
                            <div *ngFor="let timeUnit of availableTimeUnits" class="custom-button"
                                [ngClass]="{'selected': timeUnit == selectedTimeUnit}"
                                (click)="selectedTimeUnit=timeUnit;reservation.unitType = timeUnit.unitType">
                                {{timeUnit.unit}} {{timeUnit.unitType}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showFlexibleOptions()">
                <div class="rental-days-message">
                    <div *ngIf="rentalDaysMessage==='EXACT' || rentalDaysMessage==='UNDER' ">{{
                        'bikeshop.rentals.booking.days_reserved_exact' | translate : {days: reservation.rentalDays} }}
                    </div>
                    <div *ngIf="rentalDaysMessage==='OVER'">{{ 'bikeshop.rentals.booking.days_reserved_over' | translate
                        :
                        {days: reservation.rentalDays, time: getFromDateTime()} }}</div>
                    <!-- <div *ngIf="rentalDaysMessage==='UNDER'">{{ 'bikeshop.rentals.booking.days_reserved_under' | translate : {days: reservation.rentalDays, time: reservation.selectedSlot.label} }}</div> -->
                </div>
            </div>

        </div>


    </div>

</div>


<div class="info-container" style="padding-bottom: 8px;" *ngIf="!editProducts">

    <div class="header-edit">
        <div class="label header">{{'bikeshop.shop_setup.header.rentals' | translate}}</div>
        <div class="fa fa-pencil" *ngIf="canEditReservation" (click)="beginProductsEdit()"></div>
    </div>

    <div class="products-container">
        <div *ngFor="let product of reservation.reservedProducts">
            <div class="product-item"
                [ngStyle]="{'border-color': reservation.reservedProducts && reservation.reservedProducts.length > 1 && product.reservedAccessories && product.pairMatchColor ? product.pairMatchColor : ''}">
                <div class="image">
                    <div [ngStyle]="{'background-image' : 'url('+product.imageURL+')'}"></div>
                </div>
                <div class="category">{{product.categoryName}}</div>
                <div class="title">{{product.brand}} {{product.model}}</div>
                <div class="info">{{product.color}} ({{product.size}})</div>
                <div class="info">{{product.serialNumber}}</div>
                <!-- <div class="remove-icon" *ngIf="reservation.reservationStatusID === 1 || reservation.reservationStatusID === 10"><span class="fa fa-times"></span></div> -->
            </div>
            <div *ngFor="let accessory of product.reservedAccessories" class="product-item"
                [ngStyle]="{'border-color': reservation.reservedProducts.length > 1 && product.pairMatchColor ? product.pairMatchColor : ''}">
                <div class="image">
                    <div [ngStyle]="{'background-image' : 'url('+accessory.imageURL+')'}"></div>
                </div>
                <div class="category">{{accessory.categoryName}}</div>
                <div class="title">{{accessory.brand}} {{accessory.name}}</div>
                <div class="info">{{accessory.color}} ({{accessory.size}})</div>
                <div class="info">{{accessory.serialNumber}}</div>
                <!-- <div class="remove-icon" *ngIf="reservation.reservationStatusID === 1 || reservation.reservationStatusID === 10"><span class="fa fa-times"></span></div> -->
            </div>
        </div>
    </div>
</div>

<div class="info-container" *ngIf="editProducts">
    <div class="label header">{{'bikeshop.rentals.booking.rental_products' | translate}}</div>

    <div class="filters">
        <div>
            <div class="category-filter" *ngIf="categories.length > 0">
                <div>{{ 'bikeshop.rentals.products.category' | translate }}:</div>
                <div>
                    <div *ngFor="let category of categories" class="filter-items"
                        (click)="selectCategoryFilter(category)"
                        [ngClass]="{'selected': category === selectedCategories}">
                        <div><span class="fa"
                                [ngClass]="{ 'fa-minus-circle' : category === selectedCategories, 'fa-plus-circle' : category !== selectedCategories }"></span>{{category}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="brand-filter" *ngIf="brands.length > 0">
                <div>{{ 'bikeshop.rentals.products.brand' | translate }}:</div>
                <div>
                    <div *ngFor="let brand of brands" class="filter-items" (click)="selectBrandFilter(brand)"
                        [ngClass]="{'selected': brand === selectedBrands}">
                        <div><span class="fa"
                                [ngClass]="{ 'fa-minus-circle' : brand === selectedBrands, 'fa-plus-circle' : brand !== selectedBrands }"></span>{{brand}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex" style="justify-content: space-between;align-items: flex-end;">
            <div [ngClass]="{'red': getSelectedProducts().length === 0 }">{{
                'bikeshop.rentals.booking.select_products' | translate}}</div>
            <div class="filter-right">
                <div class="p-inputgroup" style="margin-left: 30px; width: 300px; float: left;">
                    <input type="text" pInputText placeholder="{{ 'general.search' | translate }}"
                        (input)="setSearch($event.target['value'] )" />
                    <span class="p-inputgroup-addon"><i class="hubtiger-search"></i></span>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="bikesLoading" style="margin-top: 64px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div class="edit-products-container" id="product-container" *ngIf="!bikesLoading">
        <div *ngFor="let product of filteredProducts" class="product-item" [ngClass]="{ 'selected': product.selected }"
            (click)="addProduct(product)">
            <div class="image">
                <div [ngStyle]="{'background-image' : 'url('+product.imageURL+')'}"></div>
            </div>
            <div class="category">{{product.categoryName}}</div>
            <div class="title">{{product.brand}} {{product.model}}</div>
            <div class="info">{{product.color}} ({{product.size}})</div>
            <div class="info">{{product.serialNumber}}</div>
            <div class="requires-accessory" *ngIf="product.requiresAccessories"
                [ngClass]="{'required-accessory-selected' : product.selected && hasRequiredAccessory(product), 'required-accessory-not-selected' : product.selected && !hasRequiredAccessory(product)}">
                {{ 'bikeshop.rentals.booking.required_accessory' | translate }}</div>
        </div>
    </div>

    <div *ngIf="listBikesNotAvailable && listBikesNotAvailable.length > 0" class="red">
        <div class="bold">{{ 'bikeshop.rentals.booking.products_not_available' | translate }}</div>
        <ul *ngFor="let notAvailable of listBikesNotAvailable">
            <li>{{notAvailable.brand}} {{notAvailable.model}} {{notAvailable.size}} {{notAvailable.serialNumber ?
                notAvailable.serialNumber : ""}}</li>
        </ul>
    </div>
</div>

<div style="margin-top: 32px;margin-left: 16px;" *ngIf="editProducts && getSelectedProducts().length > 0">
    <div class="label header">{{'bikeshop.rentals.booking.selected_products' | translate}}</div>
</div>

<div *ngIf="editProducts">
    <div *ngFor="let product of getSelectedProducts()" class="info-container">
        <div class="flex" style="justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <div class="selected-bike">
                <div class="header">{{product.brand}} {{product.model}} / {{product.color}} ({{product.size}})</div>
                <!-- <span class="sub-header">{{product.color}} ({{product.size}})</span>  -->
                <div class="sub-header">{{product.serialNumber}}</div>
            </div>
            <button pButton (click)="product.selected = false;" class="p-button-raised"
                label="{{'bikeshop.rentals.booking.remove_product' | translate}}"></button>
        </div>
        <p-accordion>
            <p-accordionTab
                header="{{'bikeshop.rentals.booking.add_required_accessory' | translate}}    {{ getSelectedCount(product.requredAccessoryOptions) > 0 ? ('('+getSelectedCount(product.requredAccessoryOptions) + ' ' +('bikeshop.rentals.booking.selected' | translate)) +')' : '' }}"
                [ngClass]="{ 'red': !hasRequiredAccessory(product)}" *ngIf="product.requiresAccessories">
                <div *ngIf="!product.requredAccessoryOptions || product.requredAccessoryOptions.length === 0"
                    class="red">
                    {{ 'bikeshop.rentals.booking.no_required_accessories_avaliable' | translate }}
                </div>
                <div class="accessories-container"
                    *ngIf="product.requredAccessoryOptions && product.requredAccessoryOptions.length > 0">
                    <div *ngFor="let accessory of product.requredAccessoryOptions" class="accessories-item"
                        [ngClass]="{ 'selected': accessory.selected, 'used': !accessory.selected && isAccessoryAlreadyUsed(accessory, 'REQUIRED_ACCESSORY') }"
                        (click)="!accessory.selected && isAccessoryAlreadyUsed(accessory, 'REQUIRED_ACCESSORY') ? null : addAccessory(accessory)">
                        <div class="image">
                            <div [ngStyle]="{'background-image' : 'url('+accessory.imageURL+')'}"></div>
                        </div>
                        <div class="category">{{accessory.categoryName}}</div>
                        <div class="title">{{accessory.brand}} {{accessory.name}}</div>
                        <div class="info">{{accessory.color}} ({{accessory.size}})</div>
                        <div class="info">{{accessory.serialNumber}}</div>
                    </div>
                </div>
            </p-accordionTab>
            <p-accordionTab
                header="{{'bikeshop.rentals.booking.optional_accessories' | translate}}    {{ getSelectedCount(product.accessoryOptions) > 0 ? ('('+getSelectedCount(product.accessoryOptions) + ' ' +('bikeshop.rentals.booking.selected' | translate)) +')' : '' }}"
                *ngIf="product.accessoryOptions && product.accessoryOptions.length > 0">
                <div class="accessories-container">
                    <div *ngFor="let accessory of product.accessoryOptions" class="accessories-item"
                        [ngClass]="{ 'selected': accessory.selected, 'used': !accessory.selected && isAccessoryAlreadyUsed(accessory, 'OPTIONAL_ACCESSORY') }"
                        (click)="!accessory.selected && isAccessoryAlreadyUsed(accessory, 'OPTIONAL_ACCESSORY') ? null : addAccessory(accessory)">
                        <div class="image">
                            <div [ngStyle]="{'background-image' : 'url('+accessory.imageURL+')'}"></div>
                        </div>
                        <div class="category">{{accessory.categoryName}}</div>
                        <div class="title">{{accessory.brand}} {{accessory.name}}</div>
                        <div class="info">{{accessory.color}} ({{accessory.size}})</div>
                        <div class="info">{{accessory.serialNumber}}</div>
                    </div>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>

<!-- Show this only when editing products -->
<div class="info-container" *ngIf="editProducts && !editDate && !editDeliveries">
    <div style="display: flex; justify-content: space-between;">
        <button pButton (click)="editProducts = false" class="p-button-raised alternate"
            label="{{'bikeshop.rentals.booking.cancel_update' | translate}}"
            [disabled]="savingReservationProducts"></button>
        <button pButton (click)="updateReservationProducts()" class="p-button-raised accent"
            label="{{'bikeshop.rentals.booking.save_products' | translate}}"
            [disabled]="bikesLoading || savingReservationProducts || !isValid()"></button>
    </div>
</div>

<!-- Show this only when editing a date, editing a date can affect products -->
<div class="info-container" *ngIf="editDate">
    <div style="display: flex; justify-content: space-between;">
        <button pButton (click)="editDate = false;editProducts = false;" class="p-button-raised alternate"
            label="{{'bikeshop.rentals.booking.cancel_update' | translate}}"
            [disabled]="savingReservationDates"></button>
        <button pButton (click)="updateReservationDate()" class="p-button-raised accent"
            label="{{'bikeshop.rentals.booking.save_date_changes' | translate}}"
            [disabled]="savingReservationDates || !isDateChangeValid() || !isValid()"></button>
    </div>
</div>

<!-- Show this only when editing deliveries/collections, editing a delivery can affect products -->
<div class="info-container" *ngIf="editDeliveries">
    <div style="display: flex; justify-content: space-between;">
        <button pButton (click)="editDeliveries = false;editProducts = false;" class="p-button-raised alternate"
            label="{{'bikeshop.rentals.booking.cancel_update' | translate}}"
            [disabled]="savingReservationDates"></button>
        <button pButton (click)="updateReservationDeliveries()" class="p-button-raised accent"
            label="{{'bikeshop.rentals.booking.save_delivery_changes' | translate}}"
            [disabled]="savingReservationDates || !isDeliveryChangeValid() || !isValid()"></button>
    </div>
</div>





<div class="info-container" *ngIf="reservation.clientNotes && !editProducts">
    <div class="label header">{{'bikeshop.rentals.booking.customer_notes' | translate}}</div>
    <div #clientNotes class="notes" [innerHTML]="reservation.clientNotes"
        [ngClass]="{'limit-notes-height': getClientNotesHeight() > 90 && !readMoreClientNotes}"></div>
    <div class="read-more" *ngIf="getClientNotesHeight() > 90 && !readMoreClientNotes"
        (click)="readMoreClientNotes = !readMoreClientNotes">{{ 'general.read_more' | translate }}</div>
    <div class="read-more" *ngIf="readMoreClientNotes" (click)="readMoreClientNotes = !readMoreClientNotes">{{
        'general.read_less' | translate }}</div>
</div>

<div class="info-container" *ngIf="!editProducts">
    <div class="header-edit">
        <div class="label header">{{'bikeshop.rentals.booking.store_notes' | translate}}</div>
        <div class="fa fa-pencil" (click)="editStoreNotes=true" *ngIf="!editStoreNotes"></div>
    </div>
    <div *ngIf="!editStoreNotes">
        <div #storeNotes class="notes" [innerHTML]="reservation.storeNotes"
            [ngClass]="{'limit-notes-height': getStoreNotesHeight() > 90 && !readMoreStoreNotes}"></div>
        <div class="read-more" *ngIf="getStoreNotesHeight() > 90 && !readMoreStoreNotes"
            (click)="readMoreStoreNotes = !readMoreStoreNotes">{{ 'general.read_more' | translate }}</div>
        <div class="read-more" *ngIf="readMoreStoreNotes" (click)="readMoreStoreNotes = !readMoreStoreNotes">{{
            'general.read_less' | translate }}</div>
    </div>
    <div class="margin-top-8" *ngIf="editStoreNotes">
        <div class="p-inputgroup">
            <textarea [rows]="2" [(ngModel)]="reservation.storeNotes" pInputTextarea [autoResize]="true"
                (blur)="updateStoreNote()" class="p-fluid"></textarea>
            <span class="p-inputgroup-addon" (click)="updateStoreNote()"><i class="fa fa-check" [ngClass]="{
          red:  reservation.storeNotes && reservation.storeNotes.length > 0
        }"></i></span>
        </div>
    </div>
</div>

<div class="info-container" *ngIf="!editProducts">
    <div class="status-container">
        <div id="status-button" *ngFor="let status of reservationStatuses"
            [ngClass]="{'selected' : status.key === reservation.reservationStatusID, 'busy': updatingStatus}"
            (click)="updateReservationStatus(status)">
            <div *ngIf="status.key !== reservation.reservationStatusID" id="underline"></div>
            <a>{{status.label}}</a>
        </div>
    </div>
    <div *ngIf="updatingStatus" style="margin-top: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>
</div>

<div *ngIf="serviceIndicatorRecords && serviceIndicatorRecords.length > 0"
    class="info-container service-indicator-container">
    <app-reservation-product-service-indicator
        [serviceIndicatorRecords]="serviceIndicatorRecords" [reservation]="reservation" ></app-reservation-product-service-indicator>
</div>

<div class="info-container waivers-not-signed" *ngIf="!isWaiverSigned() && !editProducts">
    {{ 'bikeshop.rentals.booking.waivers_not_signed' | translate}}
</div>

<app-rental-payment-status *ngIf="!editProducts" [partner]="partner" [countryData]="countryData"
    [reservation]="reservation" [reservationPaymentHistory]="reservationPaymentHistory"></app-rental-payment-status>

<div class="info-container" *ngIf="hasProductCustomQuestions">

    <div class="header-edit">
        <div class="label header">{{'bikeshop.rentals.booking.product_custom_question' | translate}}</div>
    </div>

    <div class="question-container">
        <div *ngFor="let product of getProductsWithCustomQuestions()">
            <div>{{product.brand}} {{product.model}} {{product.yearModel}} {{product.size}}
                {{product.serialNumber}}</div>
            <ul>
                <li *ngFor="let question of product.customCategoryQuestions">
                    <div class="row">
                        <div class="col-md-3 label">{{question.question}}</div>
                        <div class="col-md-9 label">{{ question.response === 'true' ? ('general.yes' | translate) :
                            question.response === 'false' ? ('general.no' | translate) : question.response}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>

<div style="padding-bottom: 64px"></div>